import { useSubaccountContext } from 'client/context/subaccount/SubaccountContext';
import { useIsPrivyEmbeddedWallet } from 'client/hooks/util/useIsPrivyEmbeddedWallet';
import { SubaccountSigningPreferenceType } from 'client/modules/singleSignatureSessions/types';

interface RequiresSingleSignatureSetupState {
  didLoadPersistedValue: boolean;
  isPrivyEmbeddedWallet: boolean;
  signingPreferenceType: SubaccountSigningPreferenceType | undefined;
}

export function shouldRequireSingleSignatureSetup({
  didLoadPersistedValue,
  isPrivyEmbeddedWallet,
  signingPreferenceType,
}: RequiresSingleSignatureSetupState) {
  return (
    didLoadPersistedValue && !isPrivyEmbeddedWallet && !signingPreferenceType
  );
}

/** If user has never set a signing preference hook will return true */
export function useRequiresSingleSignatureSetup() {
  const { signingPreference } = useSubaccountContext();
  const isPrivyEmbeddedWallet = useIsPrivyEmbeddedWallet();
  const { current: currentSigningPreference, didLoadPersistedValue } =
    signingPreference;

  return shouldRequireSingleSignatureSetup({
    didLoadPersistedValue,
    isPrivyEmbeddedWallet,
    signingPreferenceType: currentSigningPreference?.type,
  });
}
